import { WidgetWrapper } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';

export function PartnerConsultingWidget() {
  const { t } = useTranslate();

  return (
    <WidgetWrapper title={t('partner_consulting_title')}>
      <div className="flex flex-col gap-4">
        <p className="pb-16 md:pb-0 md:pr-48">{t('partner_consulting_text')}</p>
        <div className="relative">
          <img
            className="w-full object-contain rounded-lg overflow-hidden"
            src="https://www.valiant.ch/documents/35003/43546/BET.jpg/80ae6c10-b931-4a65-9c1b-1dd0722396c0?t=1630926172151"
            alt=""
          />
          <img
            className="w-32 object-contain rounded-full overflow-hidden border-4 border-white absolute -top-16 right-8"
            src="https://www.valiant.ch/documents/35003/1116886/-/26f88910-0f9b-df6e-2ed6-32002ded283b"
            alt=""
          />
        </div>
        <div className="flex flex-col md:flex-row flex-wrap gap-4 w-full md:px-8 md:-mt-22 md:pb-8 z-10">
          <a
            href="tel:+41319983030"
            className="md:border-2 border-white bg-primary-600 rounded-lg text-white px-4 py-2 hover:bg-primary-700 uppercase text-center"
          >
            {t('partner_consulting_button_call')}
          </a>
          <a
            href="mailto:bethlehem@valiant.ch"
            className="md:border-2 border-white bg-primary-600 rounded-lg text-white px-4 py-2 hover:bg-primary-700 uppercase text-center"
          >
            {t('partner_consulting_button_mail')}
          </a>
          <a
            href="https://www.valiant.ch/privatkunden/beratungstermin"
            target="_blank"
            rel="noopener noreferrer"
            className="md:border-2 border-white bg-primary-600 rounded-lg text-white px-4 py-2 hover:bg-primary-700 uppercase text-center"
          >
            {t('partner_consulting_button_url')}
          </a>
        </div>
      </div>
    </WidgetWrapper>
  );
}
